import { createFileRoute } from '@tanstack/react-router';
import { ExtratoPix } from '@/pages/extrato-pix';

export const Route = createFileRoute('/a/extrato-pix/')({
    component: ExtratoPix,
});
